import gql from 'graphql-tag';
import actionTypes from './constants';

/* */
export const getSubscriptionFromPGB = (client, variables) => client.query({
  query: gql`${actionTypes.gql.GET_SUBSCRIPTION_FROM_PGB}`,
  fetchPolicy: 'no-cache',
  variables,
})
  .then((res) => res.data)
  .then((data) => (data.getSubscriptionFromPGB));

/* */
export const getSubscription = (client, variables) => client.query({
  query: gql`${actionTypes.gql.GET_SUBSCRIPTION}`,
  fetchPolicy: 'no-cache',
  variables,
})
  .then((res) => res.data)
  .then((data) => (data.getSubscription));

/* */
export const getLastSubscription = (client, variables) => client.query({
  query: gql`${actionTypes.gql.GET_LAST_SUBSCRIPTION}`,
  fetchPolicy: 'no-cache',
  variables,
})
  .then((res) => res.data)
  .then((data) => (data.getLastSubscription));

/* */
export const trackSubscription = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.TRACK_SUBSCRIPTION}`,
  variables,
})
.then((res) => res.data)
.then((data) => (data.trackSubscription));

/* */
export const confirmSubscription = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.CONFIRM_SUBSCRIPTION}`,
  variables,
})
.then((res) => res.data)
.then((data) => (data.confirmSubscription));

/* */
export const getAttachedDocuments = (client, variables) => client.query({
  query: gql`${actionTypes.gql.GET_ATTACHED_DOCUMENTS}`,
  fetchPolicy: 'no-cache',
  variables,
})
  .then((res) => res.data)
  .then((data) => (data.getSubscriptionAttachedDocuments));
